module.exports = __webpack_public_path__ + "img/banner-1357.90cf4988.png";